import LpApp from "../LpApp.js";
import Environment from "./Environment.js";
import Floor from "./Floor.js";
import Fox from "./Fox.js";

export default class World
{
    constructor()
    {
        console.log("Created World.");
        this.lpApp = new LpApp();
        this.Scene = this.lpApp.Scene;
        this.Resources = this.lpApp.Resources;

        /* test cube
        const testMesh = new THREE.Mesh(
            new THREE.BoxGeometry(1,1,1),
            new THREE.MeshStandardMaterial()
        );
        this.Scene.add(testMesh);
        //*/

        this.Resources.on('loaded', () => { this.OnResourcesLoaded(); });

    }

    OnResourcesLoaded()
    {
        console.log('Resources.Loaded!');
        this.Floor = new Floor();
        this.Fox = new Fox();
        this.Environment = new Environment();
    
    }

    Update()
    {
        if(this.Fox)
            this.Fox.Update();
    }
}